
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Countup from 'vux/src/components/countup/index.vue'


export default {
props: ['orderId'],
components: {
XHeader,
Group,
Cell,
XButton,
Icon,
Actionsheet,
Toast,
Countup
},

data() {
return {
subOrderId: 0,
pageLoaded: false,
order: '',
productList: [],
address: '',
iconWidth: 50,
makePayment: false,
payHeader: '请选择支付方式',
paymentList: [],
reasonForClosePayment: '',
expresses: [],
choosePaymentMethod: '',
isSelfOrder: false,
userInfo: []
}
},

created: function () {
document.title = '订单详情'
this.$vux.loading.show({
'text': '加载中'
});
const url = this.tianYiWebUrl + '/wechat/order/ajaxGetOrderDetail';
this.$http.get(url, {params: {orderId: this.orderId}}).then(r => {
let res = r.data;
if (res.code === 200) {
this.subOrderId = res.data.subOrderId;
this.isSelfOrder = res.data.isSelfOrder
this.order = res.data.order;
this.productList = res.data.goods;
this.paymentList = res.data.paymentList.data
this.reasonForClosePayment = res.data.paymentList.message;
this.address = res.data.address;
this.expresses = res.data.expresses;
this.userInfo = res.data.userInfo
this.$vux.loading.hide();
this.pageLoaded = true;

if (this.paymentList.length === 0 && this.reasonForClosePayment !== '') {
this.$vux.alert.show(this.reasonForClosePayment)
}
}
})
},
computed: {
payment() {
return {...this.paymentList, 'cancel': '取消'}
},
payBtnText() {
return this.paymentList.length === 0 ? '暂停支付' : '支付'
}
},
methods: {
paymentText(payment_method) {
if (payment_method === 1) {
return '微信支付';
} else if (payment_method === 2) {
return '余额支付';
} else if (payment_method === 3) {
return '库存提货';
}else if (payment_method === 4) {
return '库存提货';
}
},
agentPay() {
this.doPay()
},
payBalance() {
this.choosePaymentMethod = 'balance'
this.doPay()
},
payWechat() {
this.choosePaymentMethod = 'wechat'
this.doPay()
},
doPay() {
this.$vux.loading.show({
text: '支付处理中,请勿离开页面'
});

const url = this.tianYiWebUrl + '/wechat/order/payExistentOrder'
this.$http.post(url, {paymentMethod: this.choosePaymentMethod, orderId: this.orderId})
.then(r => {
let _self = this
if (this.choosePaymentMethod === 'wechat') {
if (r.data.code === 200) {
let config = r.data.data.json;

/*微信支付*/
function onBridgeReady() {
WeixinJSBridge.invoke(
'getBrandWCPayRequest', config,
function (res) {
if (res.err_msg == "get_brand_wcpay_request:ok") {
_self.$vux.loading.hide();

_self.$vux.alert.show({
title: '恭喜，下单成功',
content: '我们将尽快安排发货',
onHide() {
_self.$router.push('/uc/order/paid')
}
})
} else {
_self.$vux.loading.hide();
let errSuffix = '';
if (res.err_desc !== undefined) {
errSuffix = '，(错误:' + res.err_desc + ')';
}

_self.$vux.alert.show({
title: '微信支付未完成',
content: '微信支付未完成，请稍后重新尝试支付.' + errSuffix,
})
}
}
);
}

if (typeof WeixinJSBridge == "undefined") {
if (document.addEventListener) {
document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
} else if (document.attachEvent) {
document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
}
} else {
onBridgeReady();
}
} else {
this.$vux.loading.hide();
this.$vux.alert.show({
title: '微信支付未完成',
content: '调用微信支付失败，请选择其他支付方式',
});
}
} else {

if (r.data.code === 200) {
this.$vux.loading.hide();
this.$vux.alert.show({
title: '恭喜，下单成功',
content: '我们将尽快安排发货',
onHide() {
_self.$router.push('/uc/order/paid')
}
})
} else {
this.$vux.loading.hide();
this.$vux.alert.show({
title: '微信支付未完成',
content: r.data.message,
})
}
}
})
},
cancel(id) {
this.$vux.loading.show({
'text': '处理中'
});
const url = this.tianYiWebUrl + '/wechat/order/cancel'
this.$http.post(url, {orderId: id}).then(r => {
if (r.data.code === 200) {
this.$vux.loading.hide();
this.$vux.alert.show({
title: '提示',
content: r.data.message,
})
} else {
this.$vux.loading.hide();
this.$vux.alert.show({
title: '提示',
content: '取消订单失败'
})
}
})
},
gotoKuaiDi100(sn) {
window.location.href = 'https://m.kuaidi100.com/result.jsp?nu=' + sn;
}
}
}



// WEBPACK FOOTER //
// ./src/components/uc/OrderDetail.vue